import RequestClient from '@shared/services/main/request-client';
import { alertSuccess, alertError } from '@shared/services/base/alerts/common-alerts';
import { humanize, toItemName } from '@shared/lib/helpers/common';
import UrlModifier from '@shared/lib/helpers/url-modifier';

/**
 * This prototype describes an Update events trait. Encapsulate business logics
 *
 * @class      UpdateCallable (name)
 */
function UpdateCallable(component) {
  this.component = component;
}

/**
 * Registers Update events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {UpdateCallable}  service      The service
 * @param      {string}       module_name  The module name
 */
UpdateCallable.prototype.registerUpdateEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.UPDATE_PROCEED] = 'onUpdateProceed';
  event_callback_map[this.event_group.UPDATE_SUCCESS] = 'onUpdateSuccess';
  event_callback_map[this.event_group.UPDATE_FAIL]    = 'onUpdateFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Update events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
UpdateCallable.prototype.removeUpdateEvents = function() {
  this.removeEvents([
    this.event_group.UPDATE_PROCEED,
    this.event_group.UPDATE_SUCCESS,
    this.event_group.UPDATE_FAIL
  ]);
  return this;
}

/**
 * Gives the request extra options,
 *
 * NOTE: this will override the same option keys
 *
 * @return     {Object}  The request extra options
 */
UpdateCallable.prototype.extraUpdateOptions = function() {
  return {};
}

/**
 * Called when update proceed.
 *
 * @param      {Object}  arg1                  The argument 1
 * @param      {object}  arg1.item             The item
 * @param      {string}  [arg1.item_key='id']  The item key
 * @param      {Object}  options  The options
 */
UpdateCallable.prototype.onUpdateProceed = function({item_key='id', item = {}}) {
  if (!Object.prototype.hasOwnProperty.call(item, item_key)) {
    console.error(
      "UpdateCallable::onUpdateProceed:",
      "Item key ["+item_key+"] missing!", item
    );
    return this;
  }
  this.addInterceptor();

  let token_source = this.renewCancelToken(RequestClient, this.event_group.UPDATE_PROCEED);
  this.getComponent().setState({loader: true});

  var url = UrlModifier.bindToUrl(
    this.update_endpoint,
    this.perpareReadParam(item_key, item[item_key])
  );

  const options = this.extraUpdateOptions();
  let request = RequestClient.put(url, item, {
    cancelToken: token_source.token,
    ...options
  });
  this.bindResultEvents(
    request,
    this.event_group.UPDATE_SUCCESS,
    this.event_group.UPDATE_FAIL
  );

  console.log("UpdateCallable::onUpdateProceed" , item, item_key);
}

/**
 * Called on update success intercept.
 */
UpdateCallable.prototype.onUpdateInterceptSuccess = function() {
  const item_name = this.item_name || toItemName(this);
  alertSuccess({message: humanize(item_name) + ' is successfully saved'});
}

/**
 * Called on update success.
 *
 * @param      {Object}  response  The response
 */
UpdateCallable.prototype.onUpdateSuccess = function(response) {
  console.log("UpdateCallable::onUpdateSuccess" , response);
}

/**
 * Called on update fail.
 *
 * @param      {Object}  error   The error
 */
UpdateCallable.prototype.onUpdateFail = function(error) {
  console.log("UpdateCallable::onUpdateFail" , error);
}

/**
 * Called on update fail intercept.
 *
 * @param      {Object}  response  The response
 */
UpdateCallable.prototype.onUpdateInterceptFail = function(response) {
  const { data: { message } } = response
  alertError({
    title: 'Update Failed',
    message: message,
  });
}


export default UpdateCallable;
